import isEmpty from 'lodash/isEmpty';
import {
  AUTH_BACKUP_CODE_LENGTH,
  AUTH_CODE_LENGTH,
  ENTER_OTP_BACKUP_CODE_SUBTITLE,
  ENTER_OTP_SUBTITLE,
  ENTER_OTP_TITLE,
} from 'common/constants/auth';
import type { AuthenticationInputFormState } from 'pages/Auth/components/AuthenticationInput';
import type { OtpTitles, OTPUriParams } from './OTP.types';

export const getOtpUriParams = (uri: string): OTPUriParams => {
  const queryString = uri.split('?')[1];

  if (!queryString) {
    return {};
  }

  return Array.from(new URLSearchParams(queryString).entries()).reduce<OTPUriParams>(
    (params, [key, value]) => ({
      ...params,
      [key.toLowerCase()]: value,
    }),
    {}
  );
};

export const normalizeOtpValue = (value: string) => value.replace(/\D/g, '').slice(0, AUTH_CODE_LENGTH);

export const normalizeBackupCodeValue = (value: string) => value
  .toLowerCase()
  .replace(/[^a-z2-7]/g, '')
  .slice(0, AUTH_BACKUP_CODE_LENGTH);

export const getOtpTitles = (useBackupCode: boolean): OtpTitles => {
  if (useBackupCode) {
    return {
      title: ENTER_OTP_TITLE,
      subtitle: ENTER_OTP_BACKUP_CODE_SUBTITLE,
    };
  }

  return {
    title: ENTER_OTP_TITLE,
    subtitle: ENTER_OTP_SUBTITLE,
  };
};

export const isOtpSubmitDisabled = (
  formState: AuthenticationInputFormState,
  isSubmitting: boolean
) => isSubmitting || isEmpty(formState.values) || !formState.isValid;
